import React from 'react';
import './PageHero.css';

export default function PageHero({ title, subtitle, breadcrumb }) {
  return (
    <section className="page-hero">
      <div className="container">
        {breadcrumb && (
          <div className="page-hero-breadcrumb">
            {breadcrumb}
          </div>
        )}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}
